import {Storage} from "@/services/Storage";

export default {
    name: 'homeScreen',
    state: {
        currentTab: 1
    },
    getters: {
        getCurrentTab: (state) => state.currentTab,
    },
    mutations: {
        setCurrentTab: (state, value = 1) => state.currentTab = value,
    },
    actions: {
        getTicketsByTab: async (context, tabNumber) => {
            let user = await Storage.getCurrentUser();
            let userID = user.id;
            let userName = user.Username;
            if (tabNumber) {
                await context.commit('setCurrentTab', tabNumber);
            }
            let tab = context.getters.getCurrentTab;
            let data = [];
            switch (tab) {
                case 1:
                    data = await context.dispatch('getTicketsByUser', {userName})
                    break;
                case 4 :
                    data = await context.dispatch('getTicketsByDate',`lastUpdated`)
                    const closedTickets = data.filter(item => item.status === "CLOSED");
                    data = closedTickets
                    break;
                case 5:
                    data = await context.dispatch('getTicketsByUser', {userName, pastDue : true})
                    break;
                case 7 :
                    data = await context.dispatch('getTicketsByDate',`createdDate`)
                    break;
                case 8 :
                    data = await context.dispatch('getOverDueTickets')
                    break;
                default:
                    data = await context.dispatch('getTicketsByUser', {userName})
            }
            context.commit('setTickets', data);
        },

        printHomeScreenTicket: (context) => {
            let user = context.getters.getCurrentUser.id;
            let currentTab = context.getters.getCurrentTab;
            switch (currentTab) {
                case 1:
                    return context.dispatch('printUserTickets', user);
                case 2:
                    return context.dispatch('printAllOpenTickets');
                case 3:
                    return context.dispatch('printTicketsDueToday');
                case 4 :
                    return context.dispatch('printTicketsClosedToday');
                case 5 :
                    return context.dispatch('printPastDueByUser', user);
                default:
                    return context.dispatch('printAllPastDue');
            }
        },
    }

}
